module.exports = __webpack_public_path__ + "img/hummingbird.2ba51ce2.png";